<template>
    <div v-if="!hints[name]" :class="'onboard-hint' + (fixed ? ' fixed' : '')">
        <a v-if="closable" @click="close" href="javascript:;" class="hide">&times;</a>
        <slot name="content" />
        <button v-if="$slots.button" @click="close">
            <slot name="button" />
        </button>
    </div>
</template>

<script>
export default {
    props: ['app', 'name', 'closable', 'fixed'],
    computed: {
        hints() {
            var _ = this,
                hints = _.app.getSetting('hints') || {};

            return hints.value || {};
        }
    },
    methods: {
        close() {
            var _ = this;

            _.hints[_.name] = true;

            _.app.requester.request({
                controller: 'settings',
                action: 'save',
                setting: {
                    name: 'hints',
                    value: _.hints
                }
            });
        }
    }
};
</script>
